import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";
import { testimonialData } from "../../static/data";
import { Autoplay } from "swiper/modules";

const Testimonial = () => {
  return (
    <section className="testimonials section">
      <div className="testimonials__container">
        <Swiper
          className="testimonials__slider"
          loop={true}
          grabCursor={true}
          spaceBetween={0}
          speed={3000}
          autoplay={{
            delay: 0,
            disableOnInteraction: false,
          }}
          breakpoints={{
            320: { slidesPerView: 1.2 },
            640: { slidesPerView: 2.2 },
            1024: { slidesPerView: 3.2 },
            1440: { slidesPerView: 4.2 },
          }}
          modules={[Autoplay]}
        >
          {[...testimonialData, ...testimonialData].map(
            (testimonial, index) => {
              const { id, name, description, img, role } = testimonial;
              // Alternate between blue and white cards
              const isBlue = index % 2 !== 0;
              return (
                <SwiperSlide key={`${id}-${index}`}>
                  <div
                    className={`testimonial__card ${isBlue ? "testimonial__card--blue" : "testimonial__card--white"}`}
                  >
                    <div className="testimonial__header">
                      <div className="testimonial__info">
                        <h3 className="testimonial__name">{name}</h3>
                        <span className="testimonial__title">
                          {role || "Founder"}
                        </span>
                      </div>
                      <img
                        src={img}
                        alt={`${name}`}
                        className="testimonial__img"
                      />
                    </div>
                    <p className="testimonial__description">{description}</p>
                  </div>
                </SwiperSlide>
              );
            },
          )}
        </Swiper>
      </div>
    </section>
  );
};

export default Testimonial;
